import { render, staticRenderFns } from "./standardOrderPayment.vue?vue&type=template&id=c4f5cab0&scoped=true"
import script from "./standardOrderPayment.vue?vue&type=script&lang=js"
export * from "./standardOrderPayment.vue?vue&type=script&lang=js"
import style0 from "./standardOrderPayment.vue?vue&type=style&index=0&id=c4f5cab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f5cab0",
  null
  
)

export default component.exports